import { AxiosInstance } from "@bps/http-client";
import { ITtmFormsOpsGateway } from "@libs/api/gateways/ttm/forms/ttm-forms-ops-gateway.interface";

import { TtmFormsRefreshOptions } from "./ttm-forms-ops-gateway.dtos";

export class TtmFormsOpsGateway implements ITtmFormsOpsGateway {
  constructor(private api: AxiosInstance) {}

  async requestRefresh(
    tenantId: string,
    options?: TtmFormsRefreshOptions
  ): Promise<void> {
    const url = `tenants/${tenantId}/refreshFormDesign`;
    await this.api.post(url, options);
  }
}
